<!-- Small Delete Confirmation Modal -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise = !minimise"></i>
    <i class="fa fa-times" (click)="cancel()"></i>
  </div>
</div>

@if (!minimise) {
<div>
  <div class="modal-footer">
    <button 
      class="save-button" 
      type="button" 
      (click)="deletePayment()"
      [disabled]="crudLoading">
      @if (crudLoading) {
<span>
        <i class="fa fa-spinner fa-pulse"></i>
      </span>
}
      Delete
    </button>
    <button 
      class="cancel-button" 
      type="button" 
      (click)="cancel()">
      Cancel
    </button>
  </div>
</div>
}
